var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeaderBottomMobile = function SvgHeaderBottomMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 375,
    height: 26,
    fill: "none",
    preserveAspectRatio: "none",
    viewBox: "0 0 375 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h375v26H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E62832",
    d: "M375 0H0v20.655c78.217-14.756 159.791 19.734 237.954-2.151C295 2.532 331 10.514 375 10.514z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EF737A",
    fillRule: "evenodd",
    d: "M375 4c-6.058 4.187-8.863 5.197-14.844 7.686-23.053 9.595-49.354 12.4-74.878 12.643-43.12.412-75.615-5.48-106.938-11.158-3.416-.62-6.818-1.237-10.219-1.842C133.553 5.169 99.114.133 51.761 5.02 35.537 6.695 18.46 12.528 0 20v-2C18.53 10.5 35.057 4.734 51.556 3.032c47.627-4.915 82.28.157 116.916 6.328 3.403.606 6.806 1.223 10.221 1.842 31.323 5.678 63.643 11.537 106.566 11.127 25.421-.242 51.423-3.04 74.129-12.49C365.212 7.417 369.031 5.627 375 1.5z",
    clipRule: "evenodd"
  })));
};
export default SvgHeaderBottomMobile;